import { Loading } from '@components/atomic/atoms';
import { getUserDisclaimers } from '@lib/api_ts/usersApi';
import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const PrivacyPolicyToAccept: React.FC = () => {
	const history = useHistory();
	const { data: userDisclaimers, isPending: isPendingUsersDisclaimers } = useQuery({
		queryKey: ['userDisclaimers'],
		queryFn: getUserDisclaimers,
	});
	const hasAcceptedBefore = userDisclaimers?.includes('privacy_policy');

	useEffect(() => {
		if (isPendingUsersDisclaimers) return;
		if (hasAcceptedBefore) {
			history.push('/projects');
		}
	}, [isPendingUsersDisclaimers, history, hasAcceptedBefore]);

	return <Loading />;
};

export default PrivacyPolicyToAccept;
